import Icon, { IconAction } from "@common/controls/Icon/component";
import { IconType } from "@common/declarations";
import { useI18n } from "@common/hooks/i18n";
import { formatToHtml } from "@common/lib/format";
import { Common } from "@common/types";
import classnames from "classnames";
import React from "react";
import ExpandableText from "../ExpandableText/component";
import ShowMoreLess from "../ShowMoreLess/component";

import "./style.less";

export interface AlertProps {
  icon?: Common.IconType;
  children: any;
  className?: string;
  color: Common.SystemColor;
  contentClassName?: string;
  isOverlay?: boolean;
  hasBackdrop?: boolean;
  opacity?: number;
}

const AlertBase = (props: AlertProps) => (
  <div
    className={classnames("alert", `${props.color}`, props.className)}
    style={{ "--colorOpacity": props.opacity } as any}
  >
    <div className={classnames("content", props.contentClassName)}>
      {props.icon && (
        <>
          <Icon icon={props.icon} />
          &nbsp;
        </>
      )}
      {props.children}
    </div>
  </div>
);
const WithBackdrop = (props: any) => (
  <div
    className={classnames("alert_overlay", {
      backdrop: props.hasBackdrop
    })}
  >
    <AlertBase {...props} />
  </div>
);

export const Alert = (props: AlertProps) => (props.isOverlay ? <WithBackdrop {...props} /> : <AlertBase {...props} />);

export interface ShowMoreTextAlertProps {
  title: string;
  description?: string | null;
  onClose?: (e: React.MouseEvent) => any;
  color: Common.SystemColor;
}
export const ShowMoreTextAlert = (props: ShowMoreTextAlertProps) => {
  const i18n = useI18n();

  if (!props.description && !props.title) return null;

  return (
    <div className="show_more_alert">
      <AlertBase color={props.color}>
        {props.description && props.title && <div className="title">{props.title}</div>}
        <ExpandableText
          lines={1}
          less={<span className="show_less pointer">{i18n.showLess}</span>}
          more={<span className="show_more pointer">{i18n.showMore}</span>}
          className="description"
          text={formatToHtml(props.description || props.title || "")}
        />
        {!!props.onClose && <IconAction className="close" icon={IconType.Cross} onClick={props.onClose} size={20} />}
      </AlertBase>
    </div>
  );
};

export type ShowMoreAlertProps = {
  children: any;
  title: string;
  color: Common.SystemColor;
};
export const ShowMoreAlert = (props: ShowMoreAlertProps) => (
  <div className="show_more_alert">
    <AlertBase color={props.color}>
      <div className="caption">{props.title}</div>

      <ShowMoreLess children={props.children} />
    </AlertBase>
  </div>
);
